<template>
    <div class="box">
        <div class="box-header">
            <h3 class="box-title">Labelisation du club</h3>
      
        </div>
        <div class="box-body">
            <h4 class="categorie-title">
                    Récapitulatif
                </h4>
            <div class="recap-totaux">
          
                
                <div class="recap-item recap-total">
                    <span class="recap-label">
                        <i class="fa fa-calculator"></i>
                        Total général
                    </span>
                    <span class="recap-valeur">
                        {{ getTotalValide() }} points
                    </span>
                </div>
                <div class="recap-item">
                    <span class="recap-label">
                        <i class="fa fa-tag label-commun"></i>
                        Critères communs
                    </span>
                    <span class="recap-valeur">
                        {{ getPoints('Commun') }} points
                    </span>
                </div>
                <div class="recap-item">
                    <span class="recap-label">
                        <i class="fa fa-tag label-art-martial"></i>
                        Art Martial
                    </span>
                    <span class="recap-valeur">
                        {{ getPoints('Art Martial') }} points
                    </span>
                </div>
                <div class="recap-item">
                    <span class="recap-label">
                        <i class="fa fa-tag label-kyorugi"></i>
                        Kyorugi
                    </span>
                    <span class="recap-valeur">
                        {{ getPoints('Kyorugi') }} points
                    </span>
                </div>
                <div class="recap-item">
                    <span class="recap-label">
                        <i class="fa fa-tag label-poomsae"></i>
                        Poomsae
                    </span>
                    <span class="recap-valeur">
                        {{ getPoints('Poomsae') }} points
                    </span>
                </div>
            </div>

            <div class="labels-eligibilite-section">
                <h4 class="categorie-title">
                    Éligibilité aux labels
                </h4>
                <div class="labels-eligibilite-container">
                    <div v-for="label in labelsDisponibles" :key="label.id" class="label-eligibilite-item">
                        <div class="label-eligibilite-header">
                            <span class="label-eligibilite-nom">
                                <i class="fa fa-tag" :class="getLabelClass(label.nom)"></i>
                                {{ label.nom }}
                            </span>
                        </div>
                        <div class="label-eligibilite-status">
                            <template >
                                <div class="niveaux-eligibilite">
                                    <span v-for="niveau in 3" :key="niveau" 
                                          :class="{
                                            'text-success': canHaveLabel && canHaveLabel.labelsFinalsEligibleAvecCommun[label.nom][niveau], 
                                            'text-muted': canHaveLabel && !canHaveLabel.labelsFinalsEligibleAvecCommun[label.nom][niveau]
                                          }">
                                        <i class="fa" :class="canHaveLabel && canHaveLabel.labelsFinalsEligibleAvecCommun[label.nom][niveau] ? 'fa-check-circle' : 'fa-times-circle'"></i>
                                        Eligible {{ niveau }} étoile{{ niveau > 1 ? 's' : '' }}
                                    </span>
                                </div>
                            </template>
                        </div>
                        <div class="label-eligibilite-current">
                            <template v-if="getLabelEnCours(label.nom)">
                                <span class="text-info">
                                    <i class="fa fa-info-circle"></i>
                                    Label en cours : {{ getLabelEnCours(label.nom).niveau }} étoile{{ getLabelEnCours(label.nom).niveau > 1 ? 's' : '' }}
                                    (jusqu'au {{ formatDate(getLabelEnCours(label.nom).date_fin) }})
                                </span>
                            </template>
                            <template v-else>
                                <span class="text-muted">
                                    <i class="fa fa-info-circle"></i>
                                    Aucun label en cours
                                </span>
                            </template>
                        </div>
                        <div class="label-eligibilite-actions">
                            <button v-if="isLabelEligible(label.nom)" 
                                    class="btn btn-primary btn-sm" 
                                    @click="ajouterLabel(label)">
                                <i class="fa fa-plus"></i> Ajouter le label
                            </button>
                            <span v-else class="text-muted">
                                Non éligible
                            </span>
                            <button v-if="getLabelEnCours(label.nom)"
                                    class="btn btn-info btn-sm export-btn" 
                                    @click="showExportModal = true; selectedLabelForExport = label">
                                <i class="fa fa-image"></i> Exporter l'image du label
                            </button>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="historique-labels-section">
                <h4 class="categorie-title">
                    Historique des labels
                </h4>
                <div class="historique-labels-container">
                    <p v-if="historiqueLabels.length === 0" class="text-muted historique-vide">
                        Aucun label n'a encore été attribué à ce club.
                    </p>
                    <table v-else class="table table-condensed historique-labels-table">
                        <thead>
                            <tr>
                                <th>Statut</th>
                                <th>Label</th>
                                <th>Niveau</th>
                                <th>Du</th>
                                <th>Au</th>
                                <th>Commentaire</th>
                                <th class="historique-actions-col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="label in historiqueLabels"
                                :key="label.id"
                                :class="'historique-ligne-' + label.statut">
                                <td>
                                    <span class="historique-badge" :class="'historique-badge-' + label.statut">
                                        <i class="fa" :class="getStatutIcone(label.statut)"></i>
                                        {{ getStatutTexte(label.statut) }}
                                    </span>
                                </td>
                                <td>
                                    <i class="fa fa-tag" :class="getLabelClass(label.label)"></i>
                                    {{ label.label }}
                                </td>
                                <td class="historique-niveau">
                                    <i v-for="n in 3" :key="n" class="fa"
                                       :class="n <= label.niveau ? 'fa-star text-warning' : 'fa-star-o'"></i>
                                    <span class="historique-niveau-texte">
                                        {{ label.niveau }} étoile{{ label.niveau > 1 ? 's' : '' }}
                                    </span>
                                </td>
                                <td>{{ label.date_debut ? formatDate(label.date_debut) : '-' }}</td>
                                <td>{{ label.date_fin ? formatDate(label.date_fin) : '-' }}</td>
                                <td class="historique-commentaire">{{ label.commentaire || '-' }}</td>
                                <td class="historique-actions">
                                    <button class="btn btn-xs btn-primary"
                                            title="Modifier ce label"
                                            @click="editerLabel(label)">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                    <button class="btn btn-xs btn-danger"
                                            title="Supprimer ce label"
                                            @click="supprimerLabel(label)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="labels-section">
                <h4 class="categorie-title">
                    Critères labélisant du club
                </h4>
                <div class="labels-container">
                    <div class="label-item label-commun" :class="{ 'label-active': hasLabel('Commun') }">
                        <div class="label-header">
                            <span class="label-nom">
                                <i class="fa fa-tag label-commun"></i>
                                Critères communs
                            </span>
                                             </div>
                        <div class="label-conditions">
                            <div class="label-condition" v-for="critere in getCriteresLabelisants('Commun')" :key="critere.id">
                                <i class="fa" :class="isCritereValide(critere) ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'"></i>
                                <span class="critere-labelisant">
                                    {{ critere.nom }}
                                    <span class="label-etoiles-requises">
                                        <span v-for="n in 3" 
                                              :key="n" 
                                              class="etoile-requise"
                                              :class="getEtoileRequiseClass(critere, n)">
                                            <i class="fa" :class="getEtoileRequiseIconClass(critere, n)"></i>
                                            <span class="etoile-numero">{{ n }}</span>
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="label-specifique-container">
                        <div class="label-item label-specifique" :class="{ 'label-active': hasLabel('Art Martial') }">
                            <div class="label-header">
                                <span class="label-nom">
                                    <i class="fa fa-tag label-art-martial"></i>
                                    Art Martial
                                </span>
                                <!-- <div class="label-status-container">
                                    <span class="label-status" :class="{'text-success': canGetLabel('Art Martial', 1), 'text-danger': !canGetLabel('Art Martial', 1)}">
                                        <i class="fa" :class="canGetLabel('Art Martial', 1) ? 'fa-check-circle' : 'fa-times-circle'"></i>
                                        <span v-if="canGetLabel('Art Martial', 1)">Éligible 1 étoile</span>
                                        <span v-else>Non éligible 1 étoile</span>
                                    </span>
                                    <span class="label-status" :class="{'text-success': canGetLabel('Art Martial', 2), 'text-danger': !canGetLabel('Art Martial', 2)}">
                                        <i class="fa" :class="canGetLabel('Art Martial', 2) ? 'fa-check-circle' : 'fa-times-circle'"></i>
                                        <span v-if="canGetLabel('Art Martial', 2)">Éligible 2 étoiles</span>
                                        <span v-else>Non éligible 2 étoiles</span>
                                    </span>
                                    <span class="label-status" :class="{'text-success': canGetLabel('Art Martial', 3), 'text-danger': !canGetLabel('Art Martial', 3)}">
                                        <i class="fa" :class="canGetLabel('Art Martial', 3) ? 'fa-check-circle' : 'fa-times-circle'"></i>
                                        <span v-if="canGetLabel('Art Martial', 3)">Éligible 3 étoiles</span>
                                        <span v-else>Non éligible 3 étoiles</span>
                                    </span>
                                </div> -->
                            </div>
                            <div class="label-conditions">
                                <div class="label-condition" v-for="critere in getCriteresLabelisants('Art Martial')" :key="critere.id">
                                    <i class="fa" :class="isCritereValide(critere) ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'"></i>
                                    <span class="critere-labelisant">
                                        {{ critere.nom }}
                                        <span class="label-etoiles-requises">
                                            <span v-for="n in 3" 
                                                  :key="n" 
                                                  class="etoile-requise"
                                                  :class="getEtoileRequiseClass(critere, n)">
                                                <i class="fa" :class="getEtoileRequiseIconClass(critere, n)"></i>
                                                <span class="etoile-numero">{{ n }}</span>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="label-item label-specifique" :class="{ 'label-active': hasLabel('Kyorugi') }">
                            <div class="label-header">
                                <span class="label-nom">
                                    <i class="fa fa-tag label-kyorugi"></i>
                                    Kyorugi
                                </span>
                                
                            </div>
                            <div class="label-conditions">
                                <div class="label-condition" v-for="critere in getCriteresLabelisants('Kyorugi')" :key="critere.id">
                                    <i class="fa" :class="isCritereValide(critere) ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'"></i>
                                    <span class="critere-labelisant">
                                        {{ critere.nom }}
                                        <span class="label-etoiles-requises">
                                            <span v-for="n in 3" 
                                                  :key="n" 
                                                  class="etoile-requise"
                                                  :class="getEtoileRequiseClass(critere, n)">
                                                <i class="fa" :class="getEtoileRequiseIconClass(critere, n)"></i>
                                                <span class="etoile-numero">{{ n }}</span>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="label-item label-specifique" :class="{ 'label-active': hasLabel('Poomsae') }">
                            <div class="label-header">
                                <span class="label-nom">
                                    <i class="fa fa-tag label-poomsae"></i>
                                    Poomsae
                                </span>
                            </div>
                            <div class="label-conditions">
                                <div class="label-condition" v-for="critere in getCriteresLabelisants('Poomsae')" :key="critere.id">
                                    <i class="fa" :class="isCritereValide(critere) ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'"></i>
                                    <span class="critere-labelisant">
                                        {{ critere.nom }}
                                        <span class="label-etoiles-requises">
                                            <span v-for="n in 3" 
                                                  :key="n" 
                                                  class="etoile-requise"
                                                  :class="getEtoileRequiseClass(critere, n)">
                                                <i class="fa" :class="getEtoileRequiseIconClass(critere, n)"></i>
                                                <span class="etoile-numero">{{ n }}</span>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-for="categorie in categories" :key="categorie.nom" class="categorie-section">
                <h4 class="categorie-title">
                    {{ categorie.nom }}
                    <span class="categorie-poids">
                        <i class="fa fa-balance-scale"></i>
                        {{ getPoidsValideCategorie(categorie) }} / {{ getPoidsTotalCategorie(categorie) }}
                    </span>
                </h4>
                <div v-for="sousCategorie in categorie.sousCategories" :key="sousCategorie.nom" class="sous-categorie-section">
                    <h5 class="sous-categorie-title">{{ sousCategorie.nom }}</h5>
                    <div class="criteres-grid">
                        <div v-for="critere in sousCategorie.criteres" :key="critere.id" class="critere-item">
                            <div class="critere-header">
                                <div class="critere-info">
                                    <div class="critere-nom">
                                        <span class="critere-titre">
                                            {{ critere.nom }}
                                            <div class="tooltip-container" v-if="(critere.categorie === 'Formations' && critere.sous_categorie === 'Participation des affilés du club aux formations Adeps') || 
                                                                            (critere.categorie === 'Pratique martiale' && critere.sous_categorie === 'Grade Dan du moniteur du club') ||
                                                                            (critere.categorie === 'Pratique martiale' && critere.sous_categorie === 'Ceintures noires formées dans le club') ||
                                                                            (critere.categorie === 'Compétitions - Kyorugi' && critere.sous_categorie === 'Participation aux compétitions Kyorugi')">
                                                <i class="fa fa-info-circle text-info"
                                                   style="cursor: help;"
                                                   @mouseover="activeTooltip = critere.id"
                                                   @mouseleave="activeTooltip = null"></i>
                                                <div class="custom-tooltip" v-show="activeTooltip === critere.id">
                                                    <template v-if="critere.categorie === 'Formations' && critere.sous_categorie === 'Participation des affilés du club aux formations Adeps'">
                                                        <strong>Participations aux formations Adeps :</strong><br>
                                                        <template v-if="canHaveLabel && canHaveLabel.participationsFormationAdeps">
                                                            <div v-if="canHaveLabel.participationsFormationAdeps.length==0">Aucune participation aux formations Adeps</div>
                                                            <div v-for="p in canHaveLabel.participationsFormationAdeps" :key="p.membre+formatDate(p.date)">
                                                                {{ p.membre }} - {{ p.formation }} - {{ formatDate(p.date) }}
                                                            </div>
                                                        </template>
                                                    </template>
                                                    <template v-if="critere.categorie === 'Pratique martiale' && critere.sous_categorie === 'Grade Dan du moniteur du club'">
                                                        <strong>Moniteurs diplômés :</strong><br>
                                                        <template v-if="canHaveLabel && canHaveLabel.moniteursDiplomes">
                                                            <div v-if="canHaveLabel.moniteursDiplomes.length==0">Aucun moniteur diplômé</div>
                                                            <div v-for="m in canHaveLabel.moniteursDiplomes" :key="m.membre+m.grade+Math.random()">
                                                                {{ m.nom }} {{ m.prenom }} - {{ m.grade }}
                                                            </div>
                                                        </template>
                                                    </template>
                                                    <template v-if="critere.categorie === 'Pratique martiale' && critere.sous_categorie === 'Ceintures noires formées dans le club'">
                                                        <strong>Passages de grade Dan/Poom :</strong><br>
                                                        <template v-if="canHaveLabel && canHaveLabel.passagesGradeDanPoom">
                                                            <div v-if="canHaveLabel.passagesGradeDanPoom.length==0">Aucun passage de grade Dan/Poom</div>
                                                            <div v-for="p in canHaveLabel.passagesGradeDanPoom" :key="p.membre+formatDate(p.date)+p.formation+p.grade">
                                                               {{ p.date }}  - {{p.formation}} - {{ p.membre }} - {{ p.grade }} - {{ formatDate(p.date) }}
                                                            </div>
                                                        </template>
                                                    </template>
                                                    <template v-if="critere.categorie === 'Compétitions - Kyorugi' && critere.sous_categorie === 'Participation aux compétitions Kyorugi'">
                                                        <strong>Participations aux compétitions Kyorugi :</strong><br>
                                                        <template v-if="canHaveLabel && canHaveLabel.participationAuxCompetitions">
                                                            <template v-if="critere.nom === 'Participation compétition niveau 1'">
                                                                <div v-if="canHaveLabel.participationAuxCompetitions[1].length==0">Aucune participation aux compétitions niveau 1</div>
                                                                <div v-for="p in canHaveLabel.participationAuxCompetitions[1]" :key="'niv1'+p.membre+formatDate(p.date)+p.competition">
                                                                    {{ p.date }} - {{ p.competition }} - {{ p.membre }} 
                                                                </div>
                                                            </template>
                                                            <template v-if="critere.nom === 'Participation compétition niveau 2'">
                                                                <div v-if="canHaveLabel.participationAuxCompetitions[2].length==0">Aucune participation aux compétitions niveau 2</div>
                                                                <div v-for="p in canHaveLabel.participationAuxCompetitions[2]" :key="'niv2'+p.membre+formatDate(p.date)+p.competition">
                                                                    {{ p.date }} - {{ p.competition }} - {{ p.membre }}
                                                                </div>
                                                            </template>
                                                            <template v-if="critere.nom === 'Participation compétition niveau 3'">
                                                                <div v-if="canHaveLabel.participationAuxCompetitions[3].length==0">Aucune participation aux compétitions niveau 3</div>
                                                                <div v-for="p in canHaveLabel.participationAuxCompetitions[3]" :key="'niv3'+p.membre+formatDate(p.date)+p.competition+Math.random()">
                                                                    {{ p.date }} - {{ p.competition }} - {{ p.membre }} 
                                                                </div>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>
                                        </span>
                                        <div class="critere-indicateurs">
                                            <span v-if="critere.label" class="critere-label" :class="getLabelClass(critere.label.nom)">
                                                <i class="fa fa-tag"></i> {{ critere.label.nom }}
                                            </span>
                                            <span v-else class="critere-label label-commun">
                                                <i class="fa fa-tag"></i> Critère commun
                                            </span>
                                            <span v-if="critere.est_valorisant" class="critere-indicateur text-primary">
                                                <i class="fa fa-certificate"></i>
                                                Valorisant
                                            </span>
                                            <span v-if="critere.est_labelisant" class="critere-indicateur text-warning">
                                                <i class="fa fa-star"></i>
                                                Labelisant
                                                <span class="label-etoiles-requises">
                                                    <span v-for="n in 3" 
                                                          :key="n" 
                                                          class="etoile-requise"
                                                          :class="getEtoileRequiseClass(critere, n)">
                                                        <i class="fa" :class="getEtoileRequiseIconClass(critere, n)"></i>
                                                        <span class="etoile-numero">{{ n }}</span>
                                                    </span>
                                                </span>
                                            </span>
                                            <span class="critere-indicateur">
                                                <i class="fa fa-balance-scale"></i>
                                                Pondération : {{ critere.poids }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="critere-details">
                                        <div class="critere-detail">
                                            <i class="fa fa-info-circle"></i>
                                            <span>{{ critere.explication }}</span>
                                        </div>
                                        <div class="critere-detail">
                                            <i class="fa fa-calendar"></i>
                                            <span>Période : {{ critere.periode }}</span>
                                        </div>
                                        <div class="critere-detail">
                                            <i class="fa fa-check-circle"></i>
                                            <span>Évaluation : {{ critere.evaluation }}</span>
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-primary btn-xs" @click="ajouterCritereClub(critere)">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                            <div v-if="getValidationsForCritere(critere.id).length > 0" class="validations-list">
                                <div v-for="validation in getValidationsForCritere(critere.id)" 
                                     :key="validation.id" 
                                     class="validation-item"
                                     :class="{ 'validation-active': isValidationActive(validation) }">
                                    <div v-if="isValidationActive(validation)" class="validation-dates">
                                        <div class="date-row">
                                            <span class="date-label">Date de début :</span>
                                            <span class="date-value active">{{ formatDate(validation.date_debut) }}</span>
                                        </div>
                                        <div class="date-row">
                                            <span class="date-label">Date de fin :</span>
                                            <span class="date-value active">{{ formatDate(validation.date_fin) }}</span>
                                        </div>
                                        <div v-if="validation.commentaire" class="commentaire-row">
                                            <span class="commentaire-label">Commentaire :</span>
                                            <span class="commentaire-value">{{ validation.commentaire }}</span>
                                        </div>
                                        <div class="date-row">
                                            <span class="date-label">Créé le :</span>
                                            <span class="date-value">{{ formatDateTime(validation.created_at) }}</span>
                                        </div>
                                    </div>
                                    <div v-else class="validation-dates">
                                        <span class="date-value">
                                            {{ formatDate(validation.date_debut) }} - {{ formatDate(validation.date_fin) }}
                                            <span v-if="validation.commentaire" class="commentaire-value">
                                                ({{ validation.commentaire }})
                                            </span>
                                            <span class="date-creation">
                                                - Créé le {{ formatDateTime(validation.created_at) }}
                                            </span>
                                        </span>
                                    </div>
                                    <button class="btn btn-xs btn-danger" @click="supprimerCritereClub(validation)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal-ajout-critere 
            :club-id="clubId"
            :critere="selectedCritere"
            @critere-ajoute="onCritereAjoute"
            v-if="showModalAjout">
        </modal-ajout-critere>

        <modal-ajout-label
            :club-id="clubId"
            :label="selectedLabel"
            @label-ajoute="onLabelAjoute"
            v-if="showModalAjoutLabel">
        </modal-ajout-label>

        <modal-edition-label
            :label="selectedLabelEdition"
            @label-modifie="onLabelModifie"
            @fermer="showModalEditionLabel = false"
            v-if="showModalEditionLabel">
        </modal-edition-label>

        <!-- Modal d'export d'image -->
        <div class="modal" v-if="showExportModal" @click.self="showExportModal = false">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Exporter l'image du label</h4>
                        <button type="button" class="close" @click="showExportModal = false">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="controls-container">
                            <div class="year-input-container">
                                <label for="yearInput">Année :</label>
                                <input 
                                    type="number" 
                                    id="yearInput" 
                                    v-model="selectedYear" 
                                    class="form-control" 
                                    style="width: 100px; display: inline-block; margin-left: 10px;"
                                    min="2000"
                                    :max="new Date().getFullYear()"
                                >
                            </div>
                            <div class="level-select-container">
                                <label for="levelSelect">Niveau :</label>
                                <select 
                                    id="levelSelect" 
                                    v-model="selectedLevel" 
                                    class="form-control"
                                    style="width: 120px; display: inline-block; margin-left: 10px;"
                                >
                                    <option value="1">Niveau 1</option>
                                    <option value="2">Niveau 2</option>
                                    <option value="3">Niveau 3</option>
                                </select>
                            </div>
                        </div>
                        <div class="preview-container">
                            <canvas ref="exportCanvas" width="800" height="400" style="display: none;"></canvas>
                            <img :src="previewImage" v-if="previewImage" class="preview-image" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" @click="showExportModal = false">Fermer</button>
                        <button type="button" class="btn btn-primary" @click="exportImage">
                            <i class="fa fa-download"></i> Télécharger
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ModalAjoutCritere from './ModalAjoutCritere'
import ModalAjoutLabel from './ModalAjoutLabel'
import ModalEditionLabel from './ModalEditionLabel'

export default {
    name: 'LabelisationClub',
    components: {
        ModalAjoutCritere,
        ModalAjoutLabel,
        ModalEditionLabel
    },
    props: {
        clubId: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            criteresClub: [],
            criteresDisponibles: [],
            canHaveLabel: null,
            showModalAjout: false,
            showModalAjoutLabel: false,
            showModalEditionLabel: false,
            selectedLabelEdition: null,
            loading: false,
            selectedCritere: null,
            selectedLabel: null,
            labelsClub: {
                'Art Martial': { etoiles: 0 },
                'Kyorugi': { etoiles: 0 },
                'Poomsae': { etoiles: 0 }
            },
            labelsDisponibles: [],
            activeTooltip: null,
            showExportModal: false,
            previewImage: null,
            fontLoaded: false,
            selectedLabelForExport: null,
            labelImages: {
                'Art Martial': {
                    '1': require('@/assets/img/labels/AM1.jpg'),
                    '2': require('@/assets/img/labels/AM2.jpg'),
                    '3': require('@/assets/img/labels/AM3.jpg') 
                },
                'Kyorugi': {
                    '1': require('@/assets/img/labels/K1.jpg'),
                    '2': require('@/assets/img/labels/K2.jpg'),
                    '3': require('@/assets/img/labels/K3.jpg')
                },
                'Poomsae': {
                    '1': require('@/assets/img/labels/P1.jpg'),
                    '2': require('@/assets/img/labels/P2.jpg'),
                    '3': require('@/assets/img/labels/P3.jpg')
                }
            },
            selectedYear: new Date().getFullYear(),
            selectedLevel: '1',
        }
    },
    computed: {
        ...mapGetters({
            getRoute: 'getRoute',
            getClub: 'getClub',
        }),
        categories() {
            // Regrouper les critères par catégorie et sous-catégorie
            const categoriesMap = new Map();
            
            this.criteresDisponibles.forEach(critere => {
                if (!categoriesMap.has(critere.categorie)) {
                    categoriesMap.set(critere.categorie, {
                        nom: critere.categorie,
                        sousCategories: new Map()
                    });
                }
                
                const categorie = categoriesMap.get(critere.categorie);
                
                if (!categorie.sousCategories.has(critere.sous_categorie)) {
                    categorie.sousCategories.set(critere.sous_categorie, {
                        nom: critere.sous_categorie,
                        criteres: []
                    });
                }
                
                categorie.sousCategories.get(critere.sous_categorie).criteres.push(critere);
            });
            
            // Convertir les Maps en Arrays pour le template
            return Array.from(categoriesMap.values()).map(categorie => ({
                ...categorie,
                sousCategories: Array.from(categorie.sousCategories.values())
            }));
        },
        historiqueLabels() {
            if (!this.canHaveLabel || !this.canHaveLabel.labelsObtenusParLeClub) return [];

            const now = new Date();

            return this.canHaveLabel.labelsObtenusParLeClub
                .map(label => {
                    const debut = label.date_debut ? new Date(label.date_debut) : null;
                    const fin = label.date_fin ? new Date(label.date_fin) : null;

                    let statut = 'actif';
                    if (debut && now < debut) {
                        statut = 'futur';
                    } else if (fin && now > fin) {
                        statut = 'expire';
                    }

                    return {
                        ...label,
                        niveau: parseInt(label.niveau, 10) || 0,
                        debut,
                        fin,
                        statut
                    };
                })
                // Du plus récent au plus ancien : date de début, puis date de fin, puis niveau
                .sort((a, b) => {
                    const debutA = a.debut ? a.debut.getTime() : 0;
                    const debutB = b.debut ? b.debut.getTime() : 0;
                    if (debutA !== debutB) return debutB - debutA;

                    const finA = a.fin ? a.fin.getTime() : 0;
                    const finB = b.fin ? b.fin.getTime() : 0;
                    if (finA !== finB) return finB - finA;

                    return b.niveau - a.niveau;
                });
        }
    },
    mounted() {
        this.getCriteresClub();
        this.getCriteresDisponibles();
        this.getLabelsDisponibles();
        this.$nextTick(() => {
            $('.formations-info').tooltip({
                placement: 'right',
                trigger: 'hover'
            });
        });
        this.loadFont();
    },
    methods: {
        getCheckIfClubCanHaveLabel() {
            let self = this;
            self.loading = true;
            self.$http.get(this.getRoute('Labelisation.checkIfClubCanHaveLabel')+this.clubId)
                .then(response => {
                    self.canHaveLabel = response.body;
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération de la possibilité de labelisation du club:', error);
                    self.loading = false;
                });
        },
        getCriteresClub(force = false) {
            let self = this;
            self.loading = true;
            self.$http.get(this.getRoute('Labelisation.getCriteresClub')+this.clubId, {forceCache: force})
                .then(response => {
                    self.criteresClub = response.body;
                    self.loading = false;
                    self.getCheckIfClubCanHaveLabel();
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération des critères du club:', error);
                    self.loading = false;
                });
        },
        getCriteresDisponibles() {
            this.$http.get(this.getRoute('Labelisation.getCriteres'))
                .then(response => {
                    this.criteresDisponibles = response.body;
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération des critères disponibles:', error);
                });
        },
        getLabelsDisponibles() {
            this.$http.get(this.getRoute('Labelisation.getLabels'))
                .then(response => {
                    this.labelsDisponibles = response.body;
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération des labels disponibles:', error);
                });
        },
        ajouterCritereClub(critere) {
            if (this.isCritereActif(critere.id)) {
                if (!confirm('Un critère actif existe déjà pour ce critère. Voulez-vous tout de même en ajouter un nouveau ?')) {
                    return;
                }
            }
            this.selectedCritere = {...critere};
            this.showModalAjout = true;
            this.$nextTick(() => {
                $('#modalAjoutCritere').modal({
                    backdrop: 'static',
                    keyboard: false
                });
                $('#modalAjoutCritere').modal('show');
                $('#modalAjoutCritere').on('hidden.bs.modal', () => {
                    this.showModalAjout = false;
                    this.selectedCritere = null;
                });
            });
        },
        supprimerCritereClub(validation) {
            console.log(validation);
            if (confirm('Êtes-vous sûr de vouloir supprimer ce critère ?')) {
                this.$http.post(this.getRoute('Labelisation.deleteCritereClub'), {validation})
                    .then(() => {
                        this.getCriteresClub(true);
                    })
                    .catch(error => {
                        console.error('Erreur lors de la suppression du critère:', error);
                    });
            }
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString('fr-FR');
        },
        formatDateTime(dateTime) {
            if (!dateTime) return '';
            const date = new Date(dateTime);
            return date.toLocaleDateString('fr-FR') + ' ' + date.toLocaleTimeString('fr-FR');
        },
        getValidationsForCritere(critereId) {
            return this.criteresClub.filter(c => c.critere_id === critereId);
        },
        isValidationActive(validation) {
            const now = new Date();
            const dateDebut = new Date(validation.date_debut);
            const dateFin = new Date(validation.date_fin);
            return now >= dateDebut && now <= dateFin;
        },
        getStatutTexte(statut) {
            switch(statut) {
                case 'actif':
                    return 'Actif';
                case 'futur':
                    return 'À venir';
                default:
                    return 'Expiré';
            }
        },
        getStatutIcone(statut) {
            switch(statut) {
                case 'actif':
                    return 'fa-check-circle';
                case 'futur':
                    return 'fa-clock-o';
                default:
                    return 'fa-times-circle';
            }
        },
        getLabelClass(labelNom) {
            switch(labelNom) {
                case 'Art Martial':
                    return 'label-art-martial';
                case 'Kyorugi':
                    return 'label-kyorugi';
                case 'Poomsae':
                    return 'label-poomsae';
                default:
                    return 'label-commun';
            }
        },
        getPoidsTotalCategorie(categorie, isCommun = false, labelNom = null, isValorisant = false, isLabelisant = false) {
            // Si aucun filtre n'est spécifié, on calcule le total de la catégorie
            if (!isCommun && !labelNom && !isValorisant && !isLabelisant) {
                return categorie.sousCategories.reduce((total, sousCategorie) => {
                    const criteresPoidsPlusHaut = sousCategorie.criteres.filter(critere => critere.poids_plus_haut_compte_pour_total);
                    if (criteresPoidsPlusHaut.length > 0) {
                        const maxPoids = criteresPoidsPlusHaut.reduce((max, critere) => {
                            return Math.max(max, critere.poids);
                        }, 0);
                        return total + maxPoids;
                    } else {
                        return total + sousCategorie.criteres.reduce((sousTotal, critere) => {
                            return sousTotal + critere.poids;
                        }, 0);
                    }
                }, 0);
            }

            // Sinon, on applique les filtres
            return categorie.sousCategories.reduce((total, sousCategorie) => {
                const criteresFiltres = sousCategorie.criteres.filter(critere => {
                    if (isValorisant) return critere.est_valorisant;
                    if (isLabelisant) return critere.est_labelisant;
                    return isCommun ? !critere.label : (critere.label && critere.label.nom === labelNom);
                });
                
                const criteresPoidsPlusHaut = criteresFiltres.filter(critere => critere.poids_plus_haut_compte_pour_total);
                if (criteresPoidsPlusHaut.length > 0) {
                    const maxPoids = criteresPoidsPlusHaut.reduce((max, critere) => {
                        return Math.max(max, critere.poids);
                    }, 0);
                    return total + maxPoids;
                } else {
                    return total + criteresFiltres.reduce((sousTotal, critere) => {
                        return sousTotal + critere.poids;
                    }, 0);
                }
            }, 0);
        },
        getPoidsValideCategorie(categorie, isCommun = false, labelNom = null, isValorisant = false, isLabelisant = false) {
            const now = new Date();
            
            // Si aucun filtre n'est spécifié, on calcule le total valide de la catégorie
            if (!isCommun && !labelNom && !isValorisant && !isLabelisant) {
                return categorie.sousCategories.reduce((total, sousCategorie) => {
                    const criteresPoidsPlusHaut = sousCategorie.criteres.filter(critere => critere.poids_plus_haut_compte_pour_total);
                    if (criteresPoidsPlusHaut.length > 0) {
                        const validationsPoidsPlusHaut = criteresPoidsPlusHaut.map(critere => {
                            const validations = this.getValidationsForCritere(critere.id);
                            const hasActiveValidation = validations.some(validation => {
                                const dateDebut = new Date(validation.date_debut);
                                const dateFin = new Date(validation.date_fin);
                                return now >= dateDebut && now <= dateFin;
                            });
                            return hasActiveValidation ? critere.poids : 0;
                        });
                        const maxPoidsValide = Math.max(...validationsPoidsPlusHaut);
                        return total + maxPoidsValide;
                    } else {
                        return total + sousCategorie.criteres.reduce((sousTotal, critere) => {
                            const validations = this.getValidationsForCritere(critere.id);
                            const hasActiveValidation = validations.some(validation => {
                                const dateDebut = new Date(validation.date_debut);
                                const dateFin = new Date(validation.date_fin);
                                return now >= dateDebut && now <= dateFin;
                            });
                            return sousTotal + (hasActiveValidation ? critere.poids : 0);
                        }, 0);
                    }
                }, 0);
            }

            // Sinon, on applique les filtres
            return categorie.sousCategories.reduce((total, sousCategorie) => {
                const criteresFiltres = sousCategorie.criteres.filter(critere => {
                    if (isValorisant) return critere.est_valorisant;
                    if (isLabelisant) return critere.est_labelisant;
                    return isCommun ? !critere.label : (critere.label && critere.label.nom === labelNom);
                });
                
                const criteresPoidsPlusHaut = criteresFiltres.filter(critere => critere.poids_plus_haut_compte_pour_total);
                if (criteresPoidsPlusHaut.length > 0) {
                    const validationsPoidsPlusHaut = criteresPoidsPlusHaut.map(critere => {
                        const validations = this.getValidationsForCritere(critere.id);
                        const hasActiveValidation = validations.some(validation => {
                            const dateDebut = new Date(validation.date_debut);
                            const dateFin = new Date(validation.date_fin);
                            return now >= dateDebut && now <= dateFin;
                        });
                        return hasActiveValidation ? critere.poids : 0;
                    });
                    const maxPoidsValide = Math.max(...validationsPoidsPlusHaut);
                    return total + maxPoidsValide;
                } else {
                    return total + criteresFiltres.reduce((sousTotal, critere) => {
                        const validations = this.getValidationsForCritere(critere.id);
                        const hasActiveValidation = validations.some(validation => {
                            const dateDebut = new Date(validation.date_debut);
                            const dateFin = new Date(validation.date_fin);
                            return now >= dateDebut && now <= dateFin;
                        });
                        return sousTotal + (hasActiveValidation ? critere.poids : 0);
                    }, 0);
                }
            }, 0);
        },
        getTotalCommun() {
            return this.categories.reduce((total, categorie) => {
                return total + this.getPoidsTotalCategorie(categorie, true);
            }, 0);
        },
        getTotalCommunValide() {
            return this.categories.reduce((total, categorie) => {
                return total + this.getPoidsValideCategorie(categorie, true);
            }, 0);
        },
        getTotalLabel(labelNom) {
            return this.categories.reduce((total, categorie) => {
                return total + this.getPoidsTotalCategorie(categorie, false, labelNom);
            }, 0);
        },
        getTotalLabelValide(labelNom) {
            return this.categories.reduce((total, categorie) => {
                return total + this.getPoidsValideCategorie(categorie, false, labelNom);
            }, 0);
        },
    
        getTotalValide() {
            if (this.canHaveLabel && this.canHaveLabel.Commun && this.canHaveLabel['Art Martial'] && this.canHaveLabel.Kyorugi && this.canHaveLabel.Poomsae) {
                return this.canHaveLabel.Commun.points + 
                       this.canHaveLabel['Art Martial'].points + 
                       this.canHaveLabel.Kyorugi.points + 
                       this.canHaveLabel.Poomsae.points;
            } else {
                return '-';
            }
        },
        getTotalValorisant() {
            return this.categories.reduce((total, categorie) => {
                return total + this.getPoidsTotalCategorie(categorie, false, null, true);
            }, 0);
        },
        getTotalValorisantValide() {
            return this.categories.reduce((total, categorie) => {
                return total + this.getPoidsValideCategorie(categorie, false, null, true);
            }, 0);
        },
        getTotalLabelisant() {
            return this.categories.reduce((total, categorie) => {
                return total + this.getPoidsTotalCategorie(categorie, false, null, false, true);
            }, 0);
        },
        getTotalLabelisantValide() {
            return this.categories.reduce((total, categorie) => {
                return total + this.getPoidsValideCategorie(categorie, false, null, false, true);
            }, 0);
        },
        hasLabel(labelNom) {
            if (this.labelsClub[labelNom]) {
                return this.labelsClub[labelNom].etoiles > 0;
            } else {
                return false;
            }
        },
        getEtoileClass(labelNom, numero) {
            return {
                'fa-star': this.labelsClub[labelNom].etoiles >= numero,
                'fa-star-o': this.labelsClub[labelNom].etoiles < numero,
                'text-warning': this.labelsClub[labelNom].etoiles >= numero
            };
        },
        toggleEtoile(labelNom, numero) {
            if (this.labelsClub[labelNom].etoiles === numero) {
                this.labelsClub[labelNom].etoiles = numero - 1;
            } else {
                this.labelsClub[labelNom].etoiles = numero;
            }
            this.saveLabels();
        },
        saveLabels() {
            // TODO: Implémenter la sauvegarde des labels
            console.log('Labels à sauvegarder:', this.labelsClub);
        },
        getEtoileRequiseClass(critere, numero) {
            switch(numero) {
                case 1:
                    return { 'active': critere.labelisant_1_etoile };
                case 2:
                    return { 'active': critere.labelisant_2_etoile };
                case 3:
                    return { 'active': critere.labelisant_3_etoile };
                default:
                    return {};
            }
        },
        getEtoileRequiseIconClass(critere, numero) {
            switch(numero) {
                case 1:
                    return { 'fa-star': critere.labelisant_1_etoile, 'fa-star-o': !critere.labelisant_1_etoile };
                case 2:
                    return { 'fa-star': critere.labelisant_2_etoile, 'fa-star-o': !critere.labelisant_2_etoile };
                case 3:
                    return { 'fa-star': critere.labelisant_3_etoile, 'fa-star-o': !critere.labelisant_3_etoile };
                default:
                    return { 'fa-star-o': true };
            }
        },
        getCriteresLabelisants(labelNom) {
            if (labelNom === 'Commun') {
                return this.criteresDisponibles.filter(critere => {
                    return !critere.label && critere.est_labelisant;
                });
            }
            return this.criteresDisponibles.filter(critere => {
                return critere.label && critere.label.nom === labelNom && critere.est_labelisant;
            });
        },
        isCritereValide(critere) {
            const validations = this.getValidationsForCritere(critere.id);
            const now = new Date();
            return validations.some(validation => {
                const dateDebut = new Date(validation.date_debut);
                const dateFin = new Date(validation.date_fin);
                return now >= dateDebut && now <= dateFin;
            });
        },
        isCritereActif(critereId) {
            const validations = this.getValidationsForCritere(critereId);
            const now = new Date();
            return validations.some(validation => {
                const dateDebut = new Date(validation.date_debut);
                const dateFin = new Date(validation.date_fin);
                return now >= dateDebut && now <= dateFin;
            });
        },
        canGetLabel(labelNom, niveau) {
            const criteresLabelisants = this.getCriteresLabelisants(labelNom);
            const criteresRequis = criteresLabelisants.filter(critere => {
                switch(niveau) {
                    case 1:
                        return critere.labelisant_1_etoile;
                    case 2:
                        return critere.labelisant_2_etoile;
                    case 3:
                        return critere.labelisant_3_etoile;
                    default:
                        return false;
                }
            });
            
            return criteresRequis.every(critere => this.isCritereValide(critere));
        },
        onCritereAjoute() {
            $('#modalAjoutCritere').modal('hide');
            this.showModalAjout = false;
            this.selectedCritere = null;
            this.getCriteresClub(true);
        },
        ajouterLabel(label) {
            const niveauxEligibles = Object.entries(this.canHaveLabel.labelsFinalsEligibleAvecCommun[label.nom] || {})
                .filter(([_, value]) => value)
                .map(([key]) => parseInt(key));
            const niveauMax = Math.max(...niveauxEligibles);
            
            this.selectedLabel = {
                id: label.id,
                nom: label.nom,
                niveau: niveauMax
            };
            this.showModalAjoutLabel = true;
            this.$nextTick(() => {
                $('#modalAjoutLabel').modal('show');
            });
        },
        onLabelAjoute() {
            this.showModalAjoutLabel = false;
            this.selectedLabel = null;
            this.getCriteresClub(true);
        },
        editerLabel(label) {
            this.selectedLabelEdition = label;
            this.showModalEditionLabel = true;
            this.$nextTick(() => {
                $('#modalEditionLabel').modal('show');
            });
        },
        onLabelModifie() {
            this.showModalEditionLabel = false;
            this.selectedLabelEdition = null;
            this.getCriteresClub(true);
        },
        supprimerLabel(label) {
            const message = `Supprimer définitivement le label ${label.label} `
                + `(${label.niveau} étoile${label.niveau > 1 ? 's' : ''}) `
                + `du ${this.formatDate(label.date_debut)} au ${this.formatDate(label.date_fin)} ?\n\n`
                + `Cette action est irréversible.`;
            if (!confirm(message)) return;

            this.$http.post(this.getRoute('Labelisation.removeLabelFromClub'), {id: label.id})
                .then(() => {
                    this.getCriteresClub(true);
                })
                .catch(error => {
                    console.error('Erreur lors de la suppression du label:', error);
                    const body = error && error.body ? error.body : null;
                    alert(body && body.message
                        ? body.message
                        : 'Une erreur est survenue lors de la suppression du label');
                });
        },
        getLabelNomComplet(labelNom, niveau) {
            const label = this.labelsDisponibles.find(l => 
                l.nom.includes(labelNom) && l.nom.includes(`${niveau} étoile`)
            );
            return label ? label.nom : `${labelNom} ${niveau} étoile${niveau > 1 ? 's' : ''}`;
        },
        getPoints(labelNom) {
            if (!this.canHaveLabel) return 0;
            if (labelNom === 'Art Martial') {
                return this.canHaveLabel['Art Martial'] ? this.canHaveLabel['Art Martial'].points : 0;
            }
            return this.canHaveLabel[labelNom] ? this.canHaveLabel[labelNom].points : 0;
        },
        getlabelsFinalsEligibleAvecCommun() {
            return this.labelsDisponibles
            return this.canHaveLabel && this.canHaveLabel.labelsFinalsEligibleAvecCommun ? this.canHaveLabel.labelsFinalsEligibleAvecCommun : {};
        },
        isLabelEligible(labelNom) {
            if (!this.canHaveLabel || !this.canHaveLabel.labelsFinalsEligibleAvecCommun) return false;
            return Object.values(this.canHaveLabel.labelsFinalsEligibleAvecCommun[labelNom] || {}).some(v => v);
        },
        getLabelEtoiles(labelNom) {
            if (this.labelsClub[labelNom]) {
                return this.labelsClub[labelNom].etoiles;
            } else {
                return 0;
            }
        },
        getFormationsAdepsTooltip() {
            if (!this.canHaveLabel || !this.canHaveLabel.participationsFormationAdeps) return '';
            
            const participations = this.canHaveLabel.participationsFormationAdeps;
            return `<div class="formations-tooltip">
                <strong>Participations aux formations Adeps :</strong><br>
                ${participations.map(p => 
                    `${p.nom}: ${p.nombre} participant${p.nombre > 1 ? 's' : ''}`
                ).join('<br>')}
            </div>`;
        },
        getLabelEnCours(labelNom) {
            const actifs = this.historiqueLabels
                .filter(label => label.label === labelNom && label.statut === 'actif');
            // Le plus récemment obtenu fait foi (l'API ne garantit aucun ordre)
            return actifs.length ? actifs[0] : null;
        },
        async loadFont() {
            try {
                const fontUrl = require('@/assets/fonts/URWDINArabicMedium.ttf')
                const font = new FontFace('URWDINArabic', `url(${fontUrl})`);
                await font.load();
                document.fonts.add(font);
                this.fontLoaded = true;
            } catch (error) {
                console.error('Erreur lors du chargement de la police:', error);
            }
        },
        async generateImage() {
            if (!this.fontLoaded) {
                await this.loadFont();
            }

            if (!this.selectedLabelForExport) return;

            // Attendre que le canvas soit monté
            await this.$nextTick();

            const canvas = this.$refs.exportCanvas;
            if (!canvas) {
                console.error('Canvas not found');
                return;
            }

            const ctx = canvas.getContext('2d');
            if (!ctx) {
                console.error('Could not get canvas context');
                return;
            }

            // Charger l'image de fond appropriée
            const img = new Image();
            
            // Sélectionner l'image en fonction du type de label et du niveau sélectionné
            const imagePath = this.labelImages[this.selectedLabelForExport.nom][this.selectedLevel];
            
            try {
                await new Promise((resolve, reject) => {
                    img.onload = resolve;
                    img.onerror = (e) => {
                        console.error('Error loading image:', e);
                        reject(e);
                    };
                    img.src = imagePath;
                });

                // Dessiner l'image de fond
                const canvasWidth = canvas.width;
                const canvasHeight = canvas.height;
                const imageRatio = img.width / img.height;
                const canvasRatio = canvasWidth / canvasHeight;

                let drawWidth, drawHeight, offsetX = 0, offsetY = 0;

                if (imageRatio > canvasRatio) {
                    // L'image est plus large que le canvas
                    drawWidth = canvasWidth;
                    drawHeight = drawWidth / imageRatio;
                    offsetY = (canvasHeight - drawHeight) / 2;
                } else {
                    // L'image est plus haute que le canvas
                    drawHeight = canvasHeight;
                    drawWidth = drawHeight * imageRatio;
                    offsetX = (canvasWidth - drawWidth) / 2;
                }

                // Ajuster la hauteur du canvas à la hauteur réelle de l'image
                canvas.height = drawHeight;

                // Effacer le canvas
                ctx.clearRect(0, 0, canvasWidth, drawHeight);
                
                // Ajouter un fond blanc
                ctx.fillStyle = '#FFFFFF';
                ctx.fillRect(0, 0, canvasWidth, drawHeight);
                
                // Dessiner l'image en préservant le ratio
                ctx.drawImage(img, offsetX, 0, drawWidth, drawHeight);

                // Calculer les positions en pourcentage
                const clubX = drawWidth * 0.18 + offsetX;
                const clubY = drawHeight * 0.56;
                const yearX = drawWidth * 0.845 + offsetX;
                const yearY = drawHeight * 0.88;

                // Configurer le texte
                ctx.fillStyle = '#000000';
                
                // Texte du nom du club
                ctx.font = '12pt URWDINArabic';
                ctx.fillText(this.getClub.club, clubX, clubY);

                // Texte de l'année
                ctx.font = '38pt URWDINArabic';
                ctx.fillStyle = '#FFFFFF';
                ctx.fillText(this.selectedYear.toString(), yearX, yearY);

                // Générer l'aperçu
                this.previewImage = canvas.toDataURL('image/jpeg');
            } catch (error) {
                console.error('Error generating image:', error);
                // En cas d'erreur, essayer de charger l'image de niveau 1
                if (this.selectedLevel !== '1') {
                    this.selectedLevel = '1';
                    await this.generateImage();
                }
            }
        },
        async exportImage() {
            if (!this.previewImage) {
                await this.generateImage();
            }

            const labelEnCours = this.getLabelEnCours(this.selectedLabelForExport.nom);
            const niveau = labelEnCours ? labelEnCours.niveau : 1;

            const link = document.createElement('a');
            link.download = `label_${this.selectedLabelForExport.nom}_${this.selectedLevel}_${this.getClub.club}_${this.selectedYear}.jpg`;
            link.href = this.previewImage;
            link.click();
        }
    },
    watch: {
        showExportModal(newVal) {
            if (newVal) {
                this.generateImage();
            }
        },
        selectedYear() {
            if (this.showExportModal) {
                this.generateImage();
            }
        },
        selectedLevel() {
            if (this.showExportModal) {
                this.generateImage();
            }
        }
    }
}
</script>

<style scoped>
.categorie-section {
    margin-bottom: 20px;
}

.categorie-title {
    color: #333;
    border-bottom: 2px solid #ddd;
    padding-bottom: 5px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.categorie-poids {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    color: #666;
    padding: 3px 8px;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.05);
}

.categorie-poids i {
    color: #6c757d;
}

.sous-categorie-section {
    margin-bottom: 15px;
}

.sous-categorie-title {
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
}

.criteres-grid {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.critere-item {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 8px;
    background-color: #f9f9f9;
}

.critere-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.critere-info {
    flex-grow: 1;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
}

.critere-nom {
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.critere-label {
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 2px 6px;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.05);
}

.critere-label i {
    font-size: 10px;
}

.label-commun i {
    /* color: #28a745; */
}

.label-art-martial i {
    color: #007bff;
}

.label-kyorugi i {
    color: #dc3545;
}

.label-poomsae i {
    color: #6f42c1;
}

.validations-list {
    margin-top: 5px;
}

.validation-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 12px;
    padding: 8px;
    border-top: 1px solid #eee;
    background-color: #f8f9fa;
    margin-top: 5px;
    border-radius: 4px;
}

.validation-dates {
    flex-grow: 1;
    margin-right: 10px;
}

.date-row, .commentaire-row {
    margin-bottom: 3px;
}

.date-label, .commentaire-label {
    font-weight: bold;
    color: #666;
    margin-right: 5px;
}

.date-value, .commentaire-value {
    color: #333;
}

.commentaire-value {
    font-style: italic;
    margin: 0 5px;
}

.btn-danger {
    margin-left: 10px;
}

.btn-xs {
    padding: 1px 5px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
}

.validation-active {
    border-left: 4px solid #28a745;
    background-color: #f8fff8;
}

.date-value.active {
    color: #28a745;
    font-weight: bold;
}

.date-creation {
    color: #666;
    font-size: 11px;
    margin-left: 5px;
}

.critere-details {
    margin-top: 5px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    font-size: 11px;
    color: #666;
}

.critere-detail {
    display: flex;
    align-items: center;
    gap: 5px;
}

.critere-detail i {
    font-size: 12px;
}

.critere-titre {
    display: flex;
    align-items: center;
    gap: 10px;
}

.critere-indicateurs {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-left: auto;
}

.critere-indicateur {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
}

.critere-indicateur i {
    font-size: 12px;
}

.text-warning {
    color: #ffc107;
}

.text-primary {
    color: #007bff;
}

.text-muted {
    color: #6c757d;
}

.recap-totaux {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #ddd;
}

.recap-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.recap-label {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 500;
}

.recap-valeur {
    font-weight: bold;
    color: #333;
}

.recap-label i {
    font-size: 14px;
}

.recap-total {
    background-color: #e9ecef;
    font-weight: bold;
}

.recap-separator {
    width: 100%;
    height: 1px;
    background-color: #ddd;
    margin: 10px 0;
}

.labels-section {
    margin-bottom: 30px;
}

.labels-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.label-specifique-container {
    display: flex;
    gap: 20px;
    width: 100%;
}

.label-specifique {
    flex: 1;
    min-width: 0;
}

.label-item {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 15px;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
}

.label-item.label-active {
    border-color: #28a745;
    background-color: #f8fff8;
}

.label-header {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 10px;
}

.label-nom {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
}

.label-status-container {
    display: flex;
    gap: 10px;
}

.label-status {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    padding: 3px 8px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.03);
}

.label-status i {
    font-size: 14px;
}

.text-success {
    color: #28a745;
}

.text-danger {
    color: #dc3545;
}

.label-conditions {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: 10px;
    padding: 10px;
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 4px;
}

.label-condition {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #666;
    padding: 5px;
    border-radius: 4px;
    background-color: white;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.label-condition i {
    font-size: 14px;
}

.label-etoiles-requises {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-left: auto;
}

.etoile-requise {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 2px 4px;
    border-radius: 4px;
    min-width: 20px;
    justify-content: center;
}

.etoile-requise i {
    font-size: 12px;
    color: #6c757d;
}

.etoile-requise.active i {
    color: #ffc107;
}

.etoile-numero {
    font-size: 9px;
    font-weight: bold;
    color: #6c757d;
}

.etoile-requise.active .etoile-numero {
    color: #ffc107;
}

.label-legend {
    display: flex;
    align-items: center;
    gap: 2px;
    margin-left: 10px;
}

.label-legend i {
    font-size: 14px;
    color: #ddd;
}

.label-legend i.text-warning {
    color: #ffc107;
}

.labels-eligibilite-section {
    margin-bottom: 30px;
}

.historique-labels-section {
    margin-bottom: 30px;
}

.historique-labels-container {
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #ddd;
}

.historique-vide {
    margin: 0;
    font-style: italic;
}

.historique-labels-table {
    margin-bottom: 0;
    background-color: white;
}

.historique-labels-table > thead > tr > th {
    border-bottom: 2px solid #ddd;
    font-size: 13px;
    text-transform: uppercase;
    color: #6c757d;
}

.historique-labels-table > tbody > tr > td {
    vertical-align: middle;
}

.historique-ligne-actif {
    background-color: #f1f9f3;
    font-weight: 500;
}

.historique-ligne-expire {
    color: #6c757d;
}

.historique-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 12px;
    white-space: nowrap;
}

.historique-badge i {
    margin-right: 4px;
}

.historique-badge-actif {
    background-color: #28a745;
    color: white;
}

.historique-badge-futur {
    background-color: #17a2b8;
    color: white;
}

.historique-badge-expire {
    background-color: #e9ecef;
    color: #6c757d;
}

.historique-niveau i {
    margin-right: 2px;
}

.historique-niveau i.fa-star-o {
    color: #ddd;
}

.historique-niveau-texte {
    margin-left: 6px;
    font-size: 13px;
}

.historique-commentaire {
    font-size: 13px;
    font-style: italic;
}

.historique-actions-col {
    width: 80px;
}

.historique-actions {
    white-space: nowrap;
}

.historique-actions .btn {
    margin-right: 4px;
}

.labels-eligibilite-container {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #ddd;
}

.label-eligibilite-item {
    flex: 1;
    min-width: 200px;
    padding: 15px;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.label-eligibilite-header {
    margin-bottom: 10px;
}

.label-eligibilite-nom {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
}

.label-eligibilite-status {
    margin: 10px 0;
    text-align: center;
    font-size: 14px;
}

.label-eligibilite-status i {
    margin-right: 5px;
}

.label-eligibilite-status .text-success {
    color: #28a745;
    font-weight: 500;
}

.label-eligibilite-status .text-muted {
    color: #6c757d;
    font-style: italic;
}

.label-eligibilite-current {
    margin: 10px 0;
    text-align: center;
    font-size: 13px;
}

.label-eligibilite-current i {
    margin-right: 5px;
}

.label-eligibilite-current .text-info {
    color: #17a2b8;
}

.label-eligibilite-current .text-muted {
    color: #6c757d;
    font-style: italic;
}

.label-eligibilite-actions {
    margin-top: 10px;
    display: flex;
    justify-content: center;
}

.label-eligibilite-actions .btn {
    padding: 5px 15px;
}

.label-eligibilite-actions .text-muted {
    font-size: 13px;
    font-style: italic;
}

.tooltip-container {
    position: relative;
    display: inline-block;
}

.custom-tooltip {
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 10px;
    background-color: #333;
    color: white;
    padding: 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.custom-tooltip::before {
    content: '';
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: transparent #333 transparent transparent;
}

.custom-tooltip div {
    margin: 3px 0;
}

.niveaux-eligibilite {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
}

.niveaux-eligibilite span {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 3px 8px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.03);
}

.niveaux-eligibilite .text-success {
    color: #28a745;
}

.niveaux-eligibilite .text-muted {
    color: #6c757d;
}

.modal {
    display: block;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1050;
}

.modal-dialog {
    margin: 30px auto;
    max-width: 900px;
    width: 95%;
}

.modal-content {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-header {
    padding: 15px;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    padding: 20px;
    text-align: center;
}

.modal-footer {
    padding: 15px;
    border-top: 1px solid #e5e5e5;
    text-align: right;
}

.preview-container {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 4px;
    margin: 0 auto;
    max-width: 800px;
}

.preview-image {
    max-width: 800px;
    width: 100%;
    height: auto;
}

.box-tools {
    display: flex;
    align-items: center;
    gap: 10px;
}

.controls-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 20px;
}

.year-input-container, .level-select-container {
    display: flex;
    align-items: center;
}

.year-input-container label, .level-select-container label {
    font-weight: bold;
    margin-right: 10px;
}

.year-input-container input, .level-select-container select {
    text-align: center;
}

.export-btn {
    margin-left: 10px;
}
</style> 


// WEBPACK FOOTER //
// src/components/Secretariat/Club/LabelisationClub.vue